import { useState, useEffect } from 'react';

const HISTORY = [
  { year: '2008', event: '中本聪发布比特币白皮书', icon: 'ri-file-paper-2-line', color: '#6B7280' },
  { year: '2015', event: '以太坊主网上线，智能合约诞生', icon: 'ri-lightbulb-line', color: '#8B5CF6' },
  { year: '2017', event: 'ICO浪潮，代币经济学被全球认知', icon: 'ri-fire-line', color: '#F59E0B' },
  { year: '2020', event: 'DeFi Summer，链上金融生态爆发', icon: 'ri-seedling-line', color: '#10B981' },
  { year: '2021', event: 'NFT元年，数字所有权概念深入人心', icon: 'ri-image-2-line', color: '#3B82F6' },
  { year: '2022', event: 'MakerDAO引入RWA抵押，机构开始觉醒', icon: 'ri-bank-line', color: '#06B6D4' },
  { year: '2023', event: 'BlackRock BUIDL上线，华尔街正式拥抱RWA', icon: 'ri-building-4-line', color: '#EC4899' },
  { year: '2024', event: 'RWA总量突破200亿美元，合规框架全球铺开', icon: 'ri-rocket-line', color: '#EF4444' },
  { year: '2025', event: '中国RWA元年，香港政策完善，全球RWA规模突破500亿美元', icon: 'ri-flag-line', color: '#F97316' },
  { year: '2026', event: '中国企业跨境RWA发行潮涌现，碳资产代币化加速，万亿赛道全面开启', icon: 'ri-star-line', color: '#EF4444' },
];

interface Era {
  year: string;
  title: string;
  subtitle: string;
  tagline: string;
  gradient: string;
  glowColor: string;
  borderColor: string;
  icon: string;
  scenes: { icon: string; title: string; desc: string }[];
  rwaImplication: string;
  marketSize: string;
  quote: string;
}

const ERAS: Era[] = [
  {
    year: '2030',
    title: '链上之城',
    subtitle: 'The Tokenized City',
    tagline: '当你购置房产的那一刻，区块链上已同步生成你的产权NFT，贷款合约自动签发，租金逐秒入账',
    gradient: 'from-amber-950 via-amber-900 to-orange-950',
    glowColor: 'rgba(251,191,36,0.15)',
    borderColor: 'border-amber-500/30',
    icon: 'ri-building-4-line',
    scenes: [
      {
        icon: 'ri-home-gear-line',
        title: '房产链上化已成惯例',
        desc: '全球前50大城市约40%的不动产实现RWA代币化。你可以用5000元购买曼哈顿某栋写字楼0.001%的产权，每天收到对应租金收益，随时在全球二级市场流转。英国已于2024年完成土地注册系统区块链迁移，成为全球首个全面推进不动产链上确权的主要经济体，中国香港、新加坡紧随其后。2030年，纸质产权证书已成历史文物，链上NFT产权凭证成为通用标准——可一键查询历史交易、抵押状态、法律纠纷记录。',
      },
      {
        icon: 'ri-leaf-line',
        title: '碳市场完全透明',
        desc: '全球碳信用通过区块链实现可溯源、不可篡改的登记与交易。每一吨碳减排对应一枚代币，从林业碳汇到光伏电站，所有数据实时上链，绿色金融彻底告别"漂绿"时代。中国全国碳市场（CEA）与自愿减排市场（CCER）完成链上整合，碳价实时可见，企业碳账户与产品碳标签全程可追溯。国际航空碳信用（CORSIA）与中国碳信用实现跨链互认，全球碳价趋于统一，推动绿色供应链的全面重构。',
      },
      {
        icon: 'ri-robot-line',
        title: '智能合约取代大量中介',
        desc: '银行、律所、公证处的大量标准化业务被智能合约自动化。贷款审批、资产过户、分红结算、违约处理均在链上自动执行，成本降低90%，速度从周级缩短至秒级。以房贷为例：自动识别贷款条件满足即触发放款，每月自动扣划，提前还款自动计算罚息，产权自动过户——全程无需任何中间机构介入，误差率趋近于零。全球前20大银行均已推出基于智能合约的RWA抵押贷款产品，传统公证业务萎缩超过60%。',
      },
      {
        icon: 'ri-global-line',
        title: '跨境融资壁垒消融',
        desc: '中国企业可直接通过香港RWA平台向全球合格投资者融资，一次发行、全球认购，无需经过繁琐的跨境汇款与多层中介，资本流动效率提升十倍。人民币结算的RWA产品在东盟国家广泛流通，"一带一路"沿线基础设施通过代币化吸引全球投资者共同持有，单笔最小认购额低至500美元，让普通投资者参与跨国基础设施建设成为可能。',
      },
      {
        icon: 'ri-radar-line',
        title: '星链卫星网络：万物互联资产的神经网络',
        desc: 'SpaceX第三代星链（Starlink Gen-3）提供全球无死角低延迟覆盖，任何物理资产——山区光伏电站、深海油气平台、非洲农业基地——都能实时接入链上价值网络。IoT传感器与Starlink网络协同，实现资产实时状态数据上链：电站发电量、设备运行状态、库存盘点，全部自动触发智能合约结算，消除人工核查成本。2030年，全球超200万台物联网资产设备已嵌入Starlink芯片，成为会自动报告的"活资产"，彻底打通物理世界与数字账本的最后一公里。',
      },
      {
        icon: 'ri-printer-line',
        title: '3D打印实物资产：设计文件即NFT，打印即确权',
        desc: '工业级3D打印技术实现精密零件、建筑构件、医疗器械的按需制造，而每一份设计文件（CAD/BIM）作为知识产权RWA代币登记在链上。购买设计文件代币即获得制造授权，打印完成后自动触发版税分配，实物产品出售后再次触发创作者收益——形成"IP确权→制造授权→实物出售"的完整链上价值闭环。建筑行业尤其受益：BIM设计文件RWA覆盖全球前100大建筑事务所，每次施工引用均自动计费，建筑设计师的版税收入首次实现了真正的被动化与全球化。',
      },
    ],
    rwaImplication: '全球RWA市场规模预计突破 10万亿美元，实体资产代币化成为主流融资方式，传统ABS/REITs产品大规模向链上迁移。',
    marketSize: '预计 $10万亿',
    quote: '「2030年，不持有任何链上资产的人，就像2010年不使用互联网的人——并非无法生存，只是正在错过整个时代。」',
  },
  {
    year: '2040',
    title: '数字文明纪元',
    subtitle: 'The Digital Civilization Era',
    tagline: '你的AI助理代表你持有资产、参与治理、获取收益——而你，只需享受生活',
    gradient: 'from-cyan-950 via-slate-900 to-teal-950',
    glowColor: 'rgba(6,182,212,0.15)',
    borderColor: 'border-cyan-500/30',
    icon: 'ri-brain-line',
    scenes: [
      {
        icon: 'ri-focus-3-line',
        title: '元宇宙资产已是刚需',
        desc: '人们每天有4-6小时生活在元宇宙空间，虚拟土地、数字建筑、数字艺术品全部通过RWA标准确权，物理世界与数字世界的资产无缝互通。你的"数字别墅"也能作为抵押品获得现实融资，元宇宙空间的商业地产租金与物理世界写字楼收益等同对待。全球五大元宇宙平台总市值超越传统商业地产市场，数字产权保护法律体系已在全球超过80个国家立法落地，数字公民与物理公民的财产权利完全等同。',
      },
      {
        icon: 'ri-robot-2-line',
        title: '机器人劳动力纳入RWA体系',
        desc: '工厂中数百万台工业机器人产生的经济价值通过代币化分配给投资者，你可以投资一台位于上海汽车厂的机器人，获得其每日"劳动收益"。这是最具时代感的新型资产形态。机器人RWA池涵盖制造、物流、医疗、农业四大领域，链上实时显示每台机器人的运行时长、维护状态、产出效益，投资者的分红精确到秒级结算。机器人劳动力代币化市场规模已超过传统股票市场，成为最重要的另类资产类别。',
      },
      {
        icon: 'ri-ai-generate',
        title: 'AI自主体拥有链上资产',
        desc: '具有法律人格的AI Agent可以持有、管理、交易RWA代币资产，为其委托人优化资产配置，7×24小时不间断运作，投资决策速度以毫秒计。人类投资的边界被彻底重新定义。AI受托人的法律责任框架已在20余个主要法域立法确认，AI管理的资产规模超过全球总资产的30%，人类的角色从"主动管理者"转变为"目标设定者"——你只需设定风险偏好和收益目标，AI完成其余所有决策。',
      },
      {
        icon: 'ri-fingerprint-line',
        title: '脑机接口接管资产管理',
        desc: '初代商业脑机接口（BCI）设备普及，用户通过神经意念直接授权区块链交易，资产操作无需手机或电脑，只需"想一下"，合规的意念签名立即执行。金融安全进入生物密码时代。每个人的神经特征取代传统密码成为最高级别的身份验证手段，脑纹与指纹、虹膜构成三重生物密码体系。量子计算已无法破解基于神经特征的加密系统，数字资产安全达到人类历史上的最高水平。',
      },
      {
        icon: 'ri-cpu-line',
        title: '量子力学重塑金融：超强算力颠覆资产定价',
        desc: '量子计算机（百万量子比特级）实现商业化部署，其并行计算能力使复杂资产组合的风险定价从数小时压缩至毫秒级。基于量子算法的RWA信用评估模型，能同时分析数百万维度的资产变量，定价精度提升100倍以上。与此同时，量子密钥分发（QKD）技术确保链上资产数据的绝对安全——即使未来更强的量子计算机也无法破解量子加密体系，为RWA资产安全提供物理级别的终极保障。全球前20大中央银行均已将量子密码系统纳入数字金融基础设施标配。',
      },
      {
        icon: 'ri-robot-line',
        title: '仿生机器人RWA池：机器劳动力的证券化革命',
        desc: '第三代仿生机器人（具备人类级灵巧度与自主学习能力）大规模部署于制造、物流、建筑、医疗等行业。这些机器人产生的经济价值通过RWA代币化分配给全球投资者：你可以认购一个覆盖500台仿生机器人的"机器劳动力基金"代币，每天获得其净利润分红。链上智能合约实时追踪每台机器人的工时、产出效率和维护状态，收益结算精确到秒。仿生机器人RWA的出现，首次让普通人可以通过持有"机器劳动力所有权"参与自动化红利，重新定义了财富分配的公平逻辑。',
      },
    ],
    rwaImplication: 'RWA市场规模突破 100万亿美元，涵盖数字世界与物理世界的全部可量化资产，成为全球第一大资产类别，超越传统股票市场总市值。',
    marketSize: '预计 $100万亿',
    quote: '「2040年，区块链不再是技术名词，就像你不会每天提起"数据库"或"互联网协议"——它只是世界运转的底层规则，无处不在，却无人提起。」',
  },
  {
    year: '2050',
    title: '文明奇点之后',
    subtitle: 'Beyond the Singularity',
    tagline: '火星殖民地的土地确权，通过以太坊Layer9链完成；太空旅游公司的股权代币，在地球与火星之间实时流通',
    gradient: 'from-violet-950 via-purple-950 to-indigo-950',
    glowColor: 'rgba(139,92,246,0.15)',
    borderColor: 'border-violet-500/30',
    icon: 'ri-planet-line',
    scenes: [
      {
        icon: 'ri-space-ship-line',
        title: '火星土地已在链上确权',
        desc: 'SpaceX第三代火星基地建成，约12万名永久居民在火星生活。火星土地通过跨星球区块链协议完成产权确认，你可以在地球购买火星0.01平方公里的土地代币，一旦该区域产生采矿或居住价值，自动触发收益分配合约。火星政府以DAO形式运作，土地税收和公共服务费用全部通过智能合约自动执行，无需传统政府机构。"地球-火星"双星经济体的总GDP已超越单一地球经济，太阳系资产成为超越国家的全新资产类别。',
      },
      {
        icon: 'ri-eye-line',
        title: '裸眼3D中的RWA世界',
        desc: '裸眼全息显示技术普及，人们在日常生活中随时可见叠加于现实的数字资产层：走进一栋楼，AR视野中即时显示该楼的代币化情况、当前持有者结构、实时租金流量——资产世界完全可视化。资产的物理形态与数字形态完全融合，每一粒粮食、每一棵树木、每一平方米土地、每一克黄金都有对应的链上孪生体，实物资产与数字代币之间的界限彻底消融。全球资产总量的99.7%已完成链上登记，成为人类有史以来最完整的资产清册。',
      },
      {
        icon: 'ri-heart-pulse-line',
        title: '人类寿命延长改写资产逻辑',
        desc: '医疗技术使平均寿命延长至130岁，传统"30年还清房贷"的金融规划被彻底颠覆。永久存续、可无限分割、随时流转的RWA代币资产，成为跨越百年的财富传承工具，遗嘱执行通过智能合约在全球秒级完成。人类一生的资产管理跨度从40年延伸至100年，"养老金"概念被"永久资产组合"取代，代际财富传承从一次性遗产继承演变为动态、持续、精细化的资产流转——父母可以向子女实时、按比例、有条件地授权资产使用权，而无需等待身后。',
      },
      {
        icon: 'ri-currency-line',
        title: '后稀缺时代的价值重构',
        desc: '机器人与AI承担了95%的物质生产劳动，人类财富增长与劳动时间脱钩。RWA代币成为"生产性资本所有权"的主要载体——你不必工作，只需持有代表工厂、机器人、AI算力的代币，便可获得文明红利的应得份额。"全民基本收益"（UBI 2.0）以代币化生产资本分红的形式发放，每个出生的人类自动获得一个初始资产组合——包含机器人算力代币、农业土地代币、基础设施代币，确保文明红利人人可及。贫富差距从资本积累的量转变为资本配置的质，智慧成为最稀缺的财富乘数。',
      },
      {
        icon: 'ri-shield-keyhole-line',
        title: '后量子密码：数字资产安全的终极防线',
        desc: '2050年，经典计算机已完全无法破解的量子密码体系（Post-Quantum Cryptography, PQC）成为全球RWA基础设施的安全标配。量子密钥分发（QKD）网络覆盖全球所有主要金融中心，每一笔RWA资产的链上操作都通过量子纠缠信道进行端到端加密——物理定律本身成为安全的最终保障，而非算法复杂度。国际电信联盟（ITU）于2046年发布全球统一的后量子安全RWA标准，确保太空中的火星节点与地球节点之间的资产通信零截获风险。区块链历史上第一次，数字资产的安全性达到了物理意义上的绝对可靠，人类终于彻底消除了密码暴力破解的恐惧，为万亿级跨星球资产流通扫清了最后的安全障碍。',
      },
    ],
    rwaImplication: '全球可量化资产的99%完成链上化，RWA市场规模突破 1000万亿美元（1京美元），人类财富的组织与流转方式完成根本性变革，区块链成为文明的基础设施。',
    marketSize: '预计 $1,000万亿',
    quote: '「2050年的人们回望2026年，就像我们今天回望1996年——难以置信曾经的世界竟然如此原始，而那些在2026年选择踏入RWA赛道的先行者，已经成为了那个时代最正确的判断者。」',
  },
];

interface VoteData {
  [key: string]: { support: number; oppose: number; userVote: 'support' | 'oppose' | null };
}

// Generate vote keys from era scenes
function getVoteKey(eraYear: string, sceneTitle: string) {
  return `vote_${eraYear}_${sceneTitle.slice(0, 10)}`;
}

const INITIAL_VOTES: Record<string, { support: number; oppose: number }> = {
  'vote_2030_链上之城': { support: 1842, oppose: 234 },
  'vote_2030_碳市场完全': { support: 2103, oppose: 187 },
  'vote_2030_智能合约取': { support: 1567, oppose: 412 },
  'vote_2030_跨境融资壁': { support: 1923, oppose: 298 },
  'vote_2030_星链卫星网': { support: 1456, oppose: 523 },
  'vote_2030_3D打印实物': { support: 987, oppose: 634 },
  'vote_2040_元宇宙资产': { support: 1234, oppose: 876 },
  'vote_2040_机器人劳动': { support: 1567, oppose: 743 },
  'vote_2040_AI自主体拥': { support: 1089, oppose: 1234 },
  'vote_2040_脑机接口接': { support: 876, oppose: 1456 },
  'vote_2040_量子力学重': { support: 1345, oppose: 567 },
  'vote_2040_仿生机器人': { support: 1123, oppose: 678 },
  'vote_2050_火星土地已': { support: 2341, oppose: 1234 },
  'vote_2050_裸眼3D中的': { support: 1876, oppose: 543 },
  'vote_2050_人类寿命延': { support: 2109, oppose: 432 },
  'vote_2050_后稀缺时代': { support: 1654, oppose: 876 },
  'vote_2050_后量子密码': { support: 1432, oppose: 345 },
};

export default function RWAFutureVision() {
  const [activeEra, setActiveEra] = useState<number | null>(null);
  const [showHistory, setShowHistory] = useState(false);
  const [votes, setVotes] = useState<VoteData>({});

  useEffect(() => {
    const stored = localStorage.getItem('rwa_future_votes');
    if (stored) {
      setVotes(JSON.parse(stored));
    }
  }, []);

  const getVoteState = (key: string) => {
    const base = INITIAL_VOTES[key] ?? { support: 0, oppose: 0 };
    const user = votes[key];
    return {
      support: base.support + (user?.support ?? 0),
      oppose: base.oppose + (user?.oppose ?? 0),
      userVote: user?.userVote ?? null,
    };
  };

  const handleVote = (key: string, type: 'support' | 'oppose') => {
    setVotes((prev) => {
      const current = prev[key];
      let updated: VoteData[string];
      if (current?.userVote === type) {
        // Cancel vote
        updated = { support: current.support - (type === 'support' ? 1 : 0), oppose: current.oppose - (type === 'oppose' ? 1 : 0), userVote: null };
      } else if (current?.userVote && current.userVote !== type) {
        // Switch vote
        updated = {
          support: (current.support ?? 0) + (type === 'support' ? 1 : -1),
          oppose: (current.oppose ?? 0) + (type === 'oppose' ? 1 : -1),
          userVote: type,
        };
      } else {
        updated = {
          support: (current?.support ?? 0) + (type === 'support' ? 1 : 0),
          oppose: (current?.oppose ?? 0) + (type === 'oppose' ? 1 : 0),
          userVote: type,
        };
      }
      const next = { ...prev, [key]: updated };
      localStorage.setItem('rwa_future_votes', JSON.stringify(next));
      return next;
    });
  };

  return (
    <section id="future-vision" className="py-0 bg-[#0A0A0F] relative overflow-hidden">
      {/* Stars bg */}
      <div className="absolute inset-0 pointer-events-none">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-white"
            style={{
              width: `${Math.random() * 2 + 0.5}px`,
              height: `${Math.random() * 2 + 0.5}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              opacity: Math.random() * 0.5 + 0.1,
            }}
          />
        ))}
      </div>

      {/* Opening Banner */}
      <div className="relative z-10 text-center py-20 px-4">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-violet-500/10 border border-violet-500/25 rounded-full mb-6">
          <i className="ri-planet-line text-violet-400 text-sm"></i>
          <span className="text-violet-300 text-sm font-semibold tracking-wider">RWA · 未来文明图景</span>
        </div>
        <h2 className="text-4xl lg:text-6xl font-black text-white mb-4 leading-tight tracking-tight">
          2030 · 2040 · 2050<br />
          <span className="bg-gradient-to-r from-amber-400 via-cyan-400 to-violet-400 bg-clip-text text-transparent">
            链上文明的三个奇点
          </span>
        </h2>
        <p className="text-gray-400 max-w-3xl mx-auto text-base lg:text-lg leading-relaxed mb-3">
          这不是科幻小说。这是基于当前技术曲线、政策走向与经济逻辑推演出的<strong className="text-white">高置信度未来图景</strong>。
          RWA不只是一个金融工具——它是人类文明迈向下一个形态的基础设施。
        </p>
        <p className="text-gray-500 text-sm max-w-2xl mx-auto mb-10">
          在你阅读这段文字的此刻，2026年，正是那个「让你二十年后骄傲自己做出了正确判断」的历史节点。
        </p>

        {/* Era selector pills */}
        <div className="flex flex-wrap justify-center gap-3">
          {ERAS.map((era, i) => (
            <button
              key={era.year}
              onClick={() => setActiveEra(activeEra === i ? null : i)}
              className={`px-6 py-2.5 rounded-full font-bold text-sm transition-all cursor-pointer whitespace-nowrap border ${
                activeEra === i
                  ? era.year === '2030'
                    ? 'bg-amber-500 border-amber-400 text-white'
                    : era.year === '2040'
                    ? 'bg-cyan-500 border-cyan-400 text-white'
                    : 'bg-violet-500 border-violet-400 text-white'
                  : 'bg-white/5 border-white/10 text-gray-300 hover:bg-white/10'
              }`}
            >
              <span className="mr-1.5"><i className={era.icon}></i></span>
              {era.year} · {era.title}
            </button>
          ))}
          <button
            onClick={() => setShowHistory(!showHistory)}
            className={`px-6 py-2.5 rounded-full font-bold text-sm transition-all cursor-pointer whitespace-nowrap border ${
              showHistory ? 'bg-gray-500 border-gray-400 text-white' : 'bg-white/5 border-white/10 text-gray-300 hover:bg-white/10'
            }`}
          >
            <span className="mr-1.5"><i className="ri-history-line"></i></span>
            2008-2026 · 历史沿革
          </button>
        </div>
      </div>

      {/* History Timeline */}
      {showHistory && (
        <div className="relative z-10 px-4 pb-16 max-w-[1200px] mx-auto">
          <div className="bg-white/3 border border-white/8 rounded-3xl p-8 lg:p-12">
            <h3 className="text-white font-black text-xl mb-8 text-center">
              <i className="ri-time-line mr-2 text-gray-400"></i>通往RWA的历史长河：2008—2026
            </h3>
            <div className="relative">
              <div className="absolute left-8 top-0 bottom-0 w-px bg-gradient-to-b from-gray-600 via-gray-500 to-orange-500 hidden md:block"></div>
              <div className="space-y-6">
                {HISTORY.map((h, i) => (
                  <div key={h.year} className="flex items-start gap-6 md:pl-20 relative">
                    <div
                      className="hidden md:flex absolute left-4 w-8 h-8 rounded-full items-center justify-center shrink-0 border-2 border-[#0A0A0F]"
                      style={{ background: h.color, top: '2px' }}
                    >
                      <i className={`${h.icon} text-white text-xs`}></i>
                    </div>
                    <div className="flex gap-4 items-start">
                      <div
                        className="text-sm font-black px-3 py-1 rounded-lg shrink-0"
                        style={{ background: `${h.color}25`, color: h.color }}
                      >
                        {h.year}
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed pt-0.5">{h.event}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-8 p-5 bg-orange-500/10 border border-orange-500/25 rounded-2xl">
              <p className="text-orange-300 text-sm leading-relaxed text-center">
                <i className="ri-arrow-right-circle-line mr-2"></i>
                <strong>我们正站在2026年的历史节点上。</strong>从比特币的一行代码到万亿美元的RWA市场，这18年的技术积累，正在化为今天每一个入场者的时代红利。
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Era detail panels */}
      {ERAS.map((era, i) => (
        activeEra === i && (
          <div key={era.year} className="relative z-10 px-4 pb-16 max-w-[1400px] mx-auto">
            {/* Era Hero */}
            <div
              className={`rounded-3xl border overflow-hidden mb-8 ${era.borderColor}`}
              style={{ background: `radial-gradient(ellipse at 50% 0%, ${era.glowColor} 0%, transparent 70%), linear-gradient(to bottom right, #0f0a1f, #050510)` }}
            >
              {/* Era Hero Image */}
              <div className="relative w-full h-56 md:h-72 overflow-hidden">
                <img
                  src={
                    era.year === '2030'
                      ? 'https://public.readdy.ai/ai/img_res/947295cb77a60d57ca97ae112ef69b08.jpg'
                      : era.year === '2040'
                      ? 'https://readdy.ai/api/search-image?query=advanced%20AI%20consciousness%20neural%20network%20human%20silhouette%20connected%20to%20vast%20digital%20universe%20glowing%20data%20streams%20neural%20pathways%20cyberpunk%20digital%20civilization%20holographic%20interface%20deep%20space%20background%20ultra%20detailed%20cinematic%20render%208k&width=1200&height=500&seq=rwa2040hero&orientation=landscape'
                      : 'https://readdy.ai/api/search-image?query=Mars%20colony%20dusk%20Earth%20visible%20sky%20futuristic%20domed%20habitats%20holographic%20blockchain%20land%20ownership%20displays%20space%20ships%20docking%20interplanetary%20civilization%20digital%20infrastructure%20cinematic%20science%20fiction%20ultra%20detailed%208k&width=1200&height=500&seq=rwa2050hero&orientation=landscape'
                  }
                  alt={`${era.year} ${era.title}`}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#050510]`} />
                <div className="absolute inset-0" style={{ background: `radial-gradient(ellipse at 50% 100%, ${era.glowColor} 0%, transparent 60%)` }} />
              </div>

              <div className="p-8 lg:p-14">
                <div className="flex flex-col lg:flex-row lg:items-center gap-6 mb-10">
                  <div
                    className="w-20 h-20 rounded-2xl flex items-center justify-center text-4xl shrink-0 border"
                    style={{ background: era.glowColor, borderColor: era.borderColor.replace('border-', '').replace('/30', '') }}
                  >
                    <i className={`${era.icon} text-white`}></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-3 mb-2">
                      <span
                        className="text-5xl font-black"
                        style={{ background: era.year === '2030' ? 'linear-gradient(135deg, #FCD34D, #F97316)' : era.year === '2040' ? 'linear-gradient(135deg, #22D3EE, #06B6D4)' : 'linear-gradient(135deg, #A78BFA, #7C3AED)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
                      >
                        {era.year}
                      </span>
                      <div>
                        <div className="text-white font-black text-2xl">{era.title}</div>
                        <div className="text-gray-400 text-sm">{era.subtitle}</div>
                      </div>
                    </div>
                    <p className="text-gray-300 text-base leading-relaxed max-w-2xl italic">「{era.tagline}」</p>
                  </div>
                </div>

                {/* Scenes Grid */}
                <div className="grid md:grid-cols-2 gap-5 mb-10">
                  {era.scenes.map((scene, si) => {
                    const voteKey = getVoteKey(era.year, scene.title);
                    const voteState = getVoteState(voteKey);
                    const totalVotes = voteState.support + voteState.oppose;
                    const supportPct = totalVotes > 0 ? Math.round((voteState.support / totalVotes) * 100) : 50;
                    return (
                    <div
                      key={scene.title}
                      className={`p-6 rounded-2xl border bg-white/3 hover:bg-white/5 transition-colors ${era.borderColor.replace('/30', '/20')}`}
                    >
                      {/* Scene Image */}
                      <div className="relative w-full h-32 rounded-xl overflow-hidden mb-4">
                        <img
                          src={
                            era.year === '2030' && si === 0 ? 'https://readdy.ai/api/search-image?query=futuristic%20real%20estate%20blockchain%20tokenization%20digital%20property%20ownership%20NFT%20token%20holographic%20cityscape%20smart%20contract%20automated%20rent%20payment%20glowing%20interface%20sci-fi%20ultra%20detailed&width=600&height=300&seq=rwa2030s1&orientation=landscape'
                            : era.year === '2030' && si === 1 ? 'https://readdy.ai/api/search-image?query=global%20carbon%20market%20blockchain%20transparent%20green%20energy%20forest%20carbon%20credits%20tokenized%20glowing%20environmental%20data%20real%20time%20tracking%20sci-fi%20clean%20energy%20visualization%20ultra%20detailed&width=600&height=300&seq=rwa2030s2&orientation=landscape'
                            : era.year === '2030' && si === 2 ? 'https://readdy.ai/api/search-image?query=smart%20contract%20automation%20replacing%20banks%20lawyers%20digital%20legal%20execution%20blockchain%20network%20financial%20automation%20glowing%20code%20matrix%20ultra%20detailed%20sci-fi&width=600&height=300&seq=rwa2030s3&orientation=landscape'
                            : era.year === '2030' && si === 3 ? 'https://readdy.ai/api/search-image?query=global%20cross%20border%20digital%20finance%20asset%20flow%20blockchain%20international%20investment%20holographic%20world%20map%20capital%20streams%20RWA%20tokens%20ultra%20detailed%20sci-fi&width=600&height=300&seq=rwa2030s4&orientation=landscape'
                            : era.year === '2030' && si === 4 ? 'https://readdy.ai/api/search-image?query=SpaceX%20Starlink%20satellite%20constellation%20low%20earth%20orbit%20global%20coverage%20IoT%20sensors%20asset%20data%20upload%20blockchain%20real-time%20physical%20asset%20monitoring%20digital%20signals%20earth%20sci-fi%20ultra%20detailed%20cinematic&width=600&height=300&seq=rwa2030s5new&orientation=landscape'
                            : era.year === '2030' && si === 5 ? 'https://readdy.ai/api/search-image?query=industrial%203D%20printing%20precision%20manufacturing%20CAD%20design%20NFT%20intellectual%20property%20blockchain%20copyright%20royalty%20digital%20ownership%20laser%20metal%20printing%20factory%20sci-fi%20ultra%20detailed%20cinematic&width=600&height=300&seq=rwa2030s6new&orientation=landscape'
                            : era.year === '2040' && si === 0 ? 'https://readdy.ai/api/search-image?query=metaverse%20virtual%20real%20estate%20digital%20property%20holographic%20city%20VR%20headset%20NFT%20ownership%20augmented%20reality%20immersive%20digital%20world%20sci-fi%20ultra%20detailed%20cinematic&width=600&height=300&seq=rwa2040s1&orientation=landscape'
                            : era.year === '2040' && si === 1 ? 'https://readdy.ai/api/search-image?query=industrial%20robot%20workers%20factory%20AI%20labor%20tokenized%20investment%20blockchain%20automated%20manufacturing%20glowing%20dividend%20streams%20sci-fi%20ultra%20detailed%20cinematic&width=600&height=300&seq=rwa2040s2&orientation=landscape'
                            : era.year === '2040' && si === 2 ? 'https://readdy.ai/api/search-image?query=AI%20autonomous%20agent%20managing%20digital%20assets%20neural%20network%20investment%20portfolio%20glowing%20artificial%20intelligence%20financial%20management%20sci-fi%20ultra%20detailed&width=600&height=300&seq=rwa2040s3&orientation=landscape'
                            : era.year === '2040' && si === 3 ? 'https://readdy.ai/api/search-image?query=brain%20computer%20interface%20neural%20link%20cryptocurrency%20transaction%20authorization%20mind%20controlled%20digital%20finance%20cyberpunk%20neural%20implant%20sci-fi%20ultra%20detailed&width=600&height=300&seq=rwa2040s4&orientation=landscape'
                            : era.year === '2040' && si === 4 ? 'https://readdy.ai/api/search-image?query=quantum%20computing%20million%20qubits%20supercomputer%20glowing%20crystalline%20processor%20financial%20risk%20pricing%20asset%20valuation%20quantum%20supremacy%20laboratory%20blue%20light%20sci-fi%20ultra%20detailed%20cinematic%20professional&width=600&height=300&seq=rwa2040s5q&orientation=landscape'
                            : era.year === '2040' && si === 5 ? 'https://readdy.ai/api/search-image?query=humanoid%20bionic%20robot%20advanced%20dexterous%20arms%20factory%20floor%20tokenized%20labor%20pool%20RWA%20fund%20glowing%20energy%20lines%20mechanical%20precision%20assembly%20futuristic%20industrial%20sci-fi%20ultra%20detailed%20cinematic&width=600&height=300&seq=rwa2040s6bio&orientation=landscape'
                            : era.year === '2050' && si === 0 ? 'https://readdy.ai/api/search-image?query=Mars%20colony%20land%20ownership%20blockchain%20red%20planet%20surface%20domed%20habitat%20holographic%20NFT%20land%20title%20interplanetary%20property%20rights%20sci-fi%20ultra%20detailed%20cinematic&width=600&height=300&seq=rwa2050s1&orientation=landscape'
                            : era.year === '2050' && si === 1 ? 'https://readdy.ai/api/search-image?query=holographic%203D%20augmented%20reality%20building%20asset%20information%20transparent%20ownership%20structure%20digital%20twin%20real%20world%20city%20sci-fi%20ultra%20detailed%20cinematic%208k&width=600&height=300&seq=rwa2050s2&orientation=landscape'
                            : era.year === '2050' && si === 2 ? 'https://readdy.ai/api/search-image?query=longevity%20medicine%20human%20life%20extension%20120%20years%20intergenerational%20wealth%20transfer%20blockchain%20smart%20will%20digital%20inheritance%20sci-fi%20ultra%20detailed&width=600&height=300&seq=rwa2050s3&orientation=landscape'
                            : era.year === '2050' && si === 3 ? 'https://readdy.ai/api/search-image?query=post%20scarcity%20civilization%20universal%20basic%20income%20token%20robot%20economy%20automated%20production%20wealth%20distribution%20blockchain%20utopia%20sci-fi%20ultra%20detailed%20cinematic&width=600&height=300&seq=rwa2050s4&orientation=landscape'
                            : 'https://readdy.ai/api/search-image?query=post%20quantum%20cryptography%20PQC%20quantum%20key%20distribution%20QKD%20network%20satellite%20interplanetary%20blockchain%20encryption%20absolute%20security%20glowing%20shield%20light%20beam%20quantum%20entanglement%20secure%20finance%20sci-fi%20cinematic%20ultra%20detailed&width=600&height=300&seq=rwa2050s5pqc&orientation=landscape'
                          }
                          alt={scene.title}
                          className="w-full h-full object-cover object-top"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                      </div>
                      <div className="flex items-start gap-4 mb-4">
                        <div
                          className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
                          style={{ background: era.glowColor }}
                        >
                          <i className={`${scene.icon} text-white text-base`}></i>
                        </div>
                        <div>
                          <h4 className="text-white font-bold mb-2 text-base">{scene.title}</h4>
                          <p className="text-gray-400 text-sm leading-relaxed">{scene.desc}</p>
                        </div>
                      </div>
                      {/* Vote Section */}
                      <div className="border-t border-white/8 pt-4">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-xs text-gray-500 flex items-center gap-1">
                            <i className="ri-bar-chart-horizontal-line"></i>
                            你认为这个预测会实现吗？
                          </span>
                          <span className="text-xs text-gray-600">{totalVotes.toLocaleString()} 人投票</span>
                        </div>
                        <div className="h-1.5 bg-white/10 rounded-full overflow-hidden mb-3">
                          <div
                            className="h-full rounded-full transition-all duration-500"
                            style={{
                              width: `${supportPct}%`,
                              background: era.year === '2030' ? 'linear-gradient(90deg,#FCD34D,#F97316)' : era.year === '2040' ? 'linear-gradient(90deg,#22D3EE,#06B6D4)' : 'linear-gradient(90deg,#A78BFA,#7C3AED)',
                            }}
                          ></div>
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleVote(voteKey, 'support')}
                            className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer border ${voteState.userVote === 'support' ? 'bg-green-500/20 border-green-500/40 text-green-400' : 'bg-white/5 border-white/10 text-gray-400 hover:bg-white/10'}`}
                          >
                            <i className="ri-thumb-up-line"></i>支持 {supportPct}%
                          </button>
                          <button
                            onClick={() => handleVote(voteKey, 'oppose')}
                            className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer border ${voteState.userVote === 'oppose' ? 'bg-red-500/20 border-red-500/40 text-red-400' : 'bg-white/5 border-white/10 text-gray-400 hover:bg-white/10'}`}
                          >
                            <i className="ri-thumb-down-line"></i>反对 {100 - supportPct}%
                          </button>
                        </div>
                      </div>
                    </div>
                    );
                  })}
                </div>

                {/* RWA Implication */}
                <div
                  className={`p-6 rounded-2xl border mb-6 ${era.borderColor}`}
                  style={{ background: era.glowColor }}
                >
                  <div className="flex items-start gap-3">
                    <i className="ri-bar-chart-2-line text-white text-xl mt-0.5 shrink-0"></i>
                    <div>
                      <div className="text-white font-bold mb-2 text-sm">RWA市场规模预测</div>
                      <div className="text-white text-2xl font-black mb-2">{era.marketSize}</div>
                      <p className="text-gray-300 text-sm leading-relaxed">{era.rwaImplication}</p>
                    </div>
                  </div>
                </div>

                {/* Quote */}
                <blockquote className="border-l-4 border-white/20 pl-5">
                  <p className="text-gray-300 text-sm leading-relaxed italic">{era.quote}</p>
                </blockquote>
              </div>
            </div>
          </div>
        )
      ))}

      {/* All-eras overview cards (when none selected) */}
      {activeEra === null && !showHistory && (
        <div className="relative z-10 px-4 pb-20 max-w-[1400px] mx-auto">
          <div className="grid lg:grid-cols-3 gap-6">
            {ERAS.map((era, i) => (
              <div
                key={era.year}
                onClick={() => setActiveEra(i)}
                className={`group cursor-pointer rounded-3xl border p-8 transition-all hover:-translate-y-1 ${era.borderColor}`}
                style={{ background: `radial-gradient(ellipse at 50% 0%, ${era.glowColor} 0%, transparent 80%), #0d0d18` }}
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: era.glowColor }}>
                    <i className={`${era.icon} text-white text-2xl`}></i>
                  </div>
                  <div>
                    <div
                      className="text-3xl font-black"
                      style={{ background: era.year === '2030' ? 'linear-gradient(135deg,#FCD34D,#F97316)' : era.year === '2040' ? 'linear-gradient(135deg,#22D3EE,#06B6D4)' : 'linear-gradient(135deg,#A78BFA,#7C3AED)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
                    >
                      {era.year}
                    </div>
                    <div className="text-white font-bold">{era.title}</div>
                  </div>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed mb-5 italic">「{era.tagline.substring(0, 60)}…」</p>
                <div className="space-y-2 mb-6">
                  {era.scenes.slice(0, 2).map((s) => (
                    <div key={s.title} className="flex items-center gap-2 text-xs text-gray-500">
                      <i className={`${s.icon} shrink-0`}></i>
                      <span>{s.title}</span>
                    </div>
                  ))}
                  <div className="text-xs text-gray-600">+ {era.scenes.length - 2} 个场景预测…</div>
                </div>
                <div className={`text-sm font-black ${era.year === '2030' ? 'text-amber-400' : era.year === '2040' ? 'text-cyan-400' : 'text-violet-400'}`}>
                  {era.marketSize}
                </div>
                <div className="mt-4 text-xs text-gray-500 group-hover:text-gray-300 transition-colors flex items-center gap-1">
                  点击展开完整图景 <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-12 text-center">
            <div className="inline-block bg-white/3 border border-white/8 rounded-2xl p-8 max-w-2xl">
              <div className="text-2xl font-black text-white mb-3">
                2026年，正是<span className="text-amber-400">最后的窗口期</span>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed mb-3 italic border-l-2 border-amber-500/60 pl-4 text-left">
                潮水不问旁观者的意见，只与踏浪者共赴远方。那些真正重塑时代的机会，从来只属于在它尚未明朗时便已笃定入场之人——拥抱RWA，不是追风逐热，而是在流沙漫漫的时代洪流中，握住那根已然命名了未来的锚绳。
              </p>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">
                所有伟大的资产类别，都有一个早期参与者享受超额回报的黄金窗口期。
                互联网是1995-2000年，移动互联网是2007-2012年，而RWA的黄金窗口，正是<strong className="text-white">此刻的2026-2030年</strong>。
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <a
                  href="#rwa-entry"
                  className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold rounded-full text-sm hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-up-circle-line mr-1.5"></i>了解RWA入门知识
                </a>
                <a
                  href="#courses"
                  className="px-6 py-2.5 bg-white/8 border border-white/15 text-white font-medium rounded-full text-sm hover:bg-white/15 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-graduation-cap-line mr-1.5"></i>查看系统培训课程
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Copyright bar */}
      <div className="relative z-10 border-t border-white/5 py-4 text-center px-4">
        <p className="text-gray-600 text-xs leading-relaxed max-w-4xl mx-auto">
          本页面所有内容（包括但不限于文字、图表、数据预测、设计排版）均受《中华人民共和国著作权法》及国际版权公约保护。
          未经RWA99.cn书面授权，任何单位或个人不得以任何形式复制、转载、传播或用于商业目的。
          引用请注明出处，违者将依法追究法律责任。
          <span className="text-gray-700 ml-2">© 2025-2026 RWA99.cn · All Rights Reserved</span>
        </p>
      </div>
    </section>
  );
}
